<div class="px-4 md:px-15 lg:px-15 w-full pb-10">
    <div class="flex flex-col items-center justify-center">
        <div class="w-full flex justify-center items-center mb-10">
            <div class="w-full flex flex-row justify-between pt-10 items-center">
                <div class="flex flex-col p-4 sm:pl-5 sm:pr-5">
                    @if (view.site && view.site.profile && view.site.profile.heading) {
                            @switch (view.site.profile.heading.position) {
                                @case (1) {
                                    <app-heading_div-type01 [options]="{heading:' Travel Deals',title:' Our Travel Deals For You ',image:'', description:'',swooshAlign: {'margin':''} }" ></app-heading_div-type01>
                                    }
                                @case (2) {
                                    <app-heading_div-type01 [options]="{heading:' Travel Deals',title:' Our Travel Deals For You ',image:'assets/xltravel/swoosh-01.svg', description:''}" ></app-heading_div-type01>
                                }
                            }
                        }
                </div>
                <div class="flex flex-row justify-between">
                    <button
                        class="bg-primary-100 hover:bg-primary-500 rounded-lg text-primary-500 hover:text-primary-100 text-sm md:text-lg font-bold py-2 px-3 sm:px-6 transition transition-duration: 500ms">
                        View More Deals
                    </button>
                </div>
            </div>
        </div>
        <div class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 lg:gap-8 mt-4"> 
            <fuse-card class=" flex flex-col  w-86 p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col w-86  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
             <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col   p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
             <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
            <fuse-card class=" flex flex-col  p-4">
                <div class="w-full sm:flex justify-between items-center mb-3">
                    <h2 class="text-2xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                        Australia
                    </h2>
                </div>
                <div class="flex items-center justify-between whitespace-normal">
                    <div class="flex flex-row max-w-md">
                        <p class="mb-2 dark:text-white">Starting From</p>
                        <span class="ml-3 text-primary-500 dark:text-accent-500">R2 800.00</span>
                    </div>
                    <a class="mr-2 pb-2" href="#">
                        <mat-icon
                            class="icon-size-6 ring-2 ring-accent-500 rounded-full text-accent-500 hover:bg-accent-500 transition transition-duration: 500ms hover:text-accent-100 mt-2"
                            [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                    </a>
                </div>
            </fuse-card>
        </div>
    </div>
</div>